var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVolume = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/latency/volume")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/latency/volume",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#00838F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/assets/audio/menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3885079,0.430107527 C19.5843972,1.61684671 23.2715626,6.25858516 23.2715626,11.6129032 C23.2715626,16.9672213 19.5843972,21.6089597 14.3885079,22.7956989 L14.3885079,22.7956989 L14.3885079,20.1705285 C18.1534277,19.0417306 20.7336841,15.5623685 20.7336841,11.6143377 C20.7336841,7.66630699 18.1534277,4.18694488 14.3885079,3.058147 L14.3885079,3.058147 Z M11.8507467,1.41323146 L11.8507467,21.815444 L5.50610576,15.4399618 L0.430107527,15.4399618 L0.430107527,7.78919186 L5.50610576,7.78919186 L11.8507467,1.41323146 Z M14.3885079,6.4756503 C16.3314084,7.44420917 17.5605525,9.43518308 17.5610696,11.6145768 C17.5634328,13.7915435 16.3326842,15.7801079 14.3885079,16.7405927 L14.3885079,16.7405927 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVolume, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/volume.59dd68e9.svg";
export { ForwardRef as ReactComponent };